import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GLOSSARY_METADATA_PATHS } from '../../constants/glossary-metadata-paths';
import { usePermission } from '../../core';
import { useGlossaryMetadataList } from '../../hooks';
import InvalidPermissionsDialog from '../../components/invalid-permissions-dialog/InvalidPermissionsDialog';
import { LandingPageWrapper } from 'components';
import { GlossaryMetadataEmptyStateIcon } from '../../assets';
import {
    getGlossaryMetadataColumns,
    GlossaryMetadataItem,
    tableHeight,
} from './glossary-metadata-helper';

export const GlossaryMetadata = (): React.JSX.Element => {
    const navigate = useNavigate();
    const { hasPermissions } = usePermission();

    const { data: glossaryMetadataList, isLoading } = useGlossaryMetadataList();
    const columns = getGlossaryMetadataColumns();

    const [displayPermissionDialog, setDisplayPermissionDialog] =
        useState(false);

    const handleAdd = (): void => {
        const permission = hasPermissions('createMetadata');
        if (permission) {
            navigate(GLOSSARY_METADATA_PATHS.CREATE_NEW_GLOSSARY_METADATA_VIEW);
        } else {
            setDisplayPermissionDialog(true);
        }
    };

    const handleDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    const handleRowClick = (row: GlossaryMetadataItem): void => {
        const { id } = row;
        navigate(`${GLOSSARY_METADATA_PATHS.LANDING_PAGE}/${id}`);
    };

    return (
        <>
            <LandingPageWrapper
                title={'Glossary'}
                showAddButton={true}
                onAddButtonClick={handleAdd}
                tableData={glossaryMetadataList?.data ?? []}
                isLoading={isLoading}
                columns={columns}
                getRowId={(row: any): string => row.id.toString()}
                onRowClick={handleRowClick}
                paginationPageSizeOptions={[25, 50, 100]}
                paginationPageSize={25}
                tableHeight={tableHeight}
                emptyStateIcon={GlossaryMetadataEmptyStateIcon}
                emptyStateBodyMessage={
                    'Add new metadata using the button at the top right of the screen.'
                }
                sortModel={[{ field: 'term', sort: 'asc' }]}
            />
            {displayPermissionDialog && (
                <InvalidPermissionsDialog
                    open={displayPermissionDialog}
                    onClose={handleDialogClose}
                />
            )}
        </>
    );
};
